import * as THREE from './three/three.module.js';


class BufferRange {
    start;
    size;
    end;
    refCnt;

    constructor(s,c) {
        this.start = s;
        this.size = c;
        this.end = this.start + this.size;
        this.refCnt = 1;
    }
}

export class BufferAllocator {
    buffer;
    stagingBuffer;
    size;
    type;

    freeBufferRanges;
    usedBufferRanges;

    constructor (size, align, type, device = null) {
        
        
        this.type = type;
        this.align = align;
        this.alignmask = this.align - 1;
        this.maxFreeRanges = 8;
        this.flag = 0;

        if(type == 2) {
            const image = new Image(size, size);

            this.buffer = new THREE.Texture(image, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.NearestFilter, THREE.NearestFilter, THREE.RGBAFormat, THREE.FloatType);
            this.size = size * this.align;
            this.lineSize = size;
            this.buffer.colorSpace = THREE.LinearSRGBColorSpace;
            this.buffer.flipY = false;
            this.buffer.generateMipmaps = false;
            this.buffer.needsUpdate = true;
        }else{

            this.device = device;
            this.size = size;

            if(type == 0)
                this.buffer = this.device.createBuffer({ size: this.size, usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST });
            else if(type == 1)
                this.buffer = this.device.createBuffer({ size: this.size, usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST });
            else if(type == 3)
                this.buffer = this.device.createBuffer({ size: this.size, usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST });
        }

        this.reset();
    }

    reset() {
        this.freeBufferRanges = [new BufferRange(0, this.size)]
        this.usedBufferRanges = [];
        this.stagingBuffer = null;
    }

    resetStaging()
    {

    }

    initializeStagingBuffer(size, copyEncoder) {

        if(this.type == 2) {

            const nLines = Math.ceil(size * 4 / this.align);

            const stagingBuffer = new Float32Array(nLines * this.lineSize * 4);

            this.stagingBuffer = new THREE.DataTexture(stagingBuffer, this.lineSize, nLines, THREE.RGBAFormat, THREE.FloatType, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.NearestFilter, THREE.NearestFilter, 1, THREE.NoColorSpace); 
            this.stagingBuffer.needsUpdate = true;

        }else
            this.stagingBuffer = this.device.createBuffer({ size: size * 4,  usage: GPUBufferUsage.COPY_SRC | GPUBufferUsage.MAP_WRITE, mappedAtCreation: true});
        
        this.stagingOffset = 0;
        this.copyEncoder = copyEncoder;
    }

    getStagingRange(size) {

        if(this.type == 2) {

            if(size > 0)
                return this.stagingBuffer.source.data.data.subarray(this.stagingOffset, this.stagingOffset + size);
            else
                return this.stagingBuffer.source.data.data.subarray(this.stagingOffset);
            
        } else {

            if(size > 0)
                return new Float32Array(this.stagingBuffer.getMappedRange(this.stagingOffset, size * 4));
            else
                return new Float32Array(this.stagingBuffer.getMappedRange(this.stagingOffset));

        }
    }

    commitStagingRange(range, size, offset = null) {

        if(!offset)
            offset = size;

        if(this.type == 2) {

            this.stagingBuffer.needsUpdate = true;
            this.copyEncoder.copyTextureToTexture(new THREE.Vector2(0, Math.floor(range.start / this.align)), this.stagingBuffer, this.buffer, 0);

        }else{

            this.copyEncoder.copyBufferToBuffer( this.stagingBuffer, this.stagingOffset, this.buffer, range.start, size * 4);
        }

        this.stagingOffset += offset * 4;
    }

    findRangeAt(start){

        for(let n=0;n<this.freeBufferRanges.length;n++)
        {
            if(this.freeBufferRanges[n].start === start)
                return this.freeBufferRanges[n];
        }
        return null;
    }

    getFreeSize(){
        let size = 0;

        for(let n=0;n<this.freeBufferRanges.length;n++){
            size += this.freeBufferRanges[n].size;
        }

        return size;

    }

    dumpInfos(){

        const free=this.getFreeSize();
        console.log(' free '+free+' / '+this.size)
    }

    mergeRanges() {

        let r = 0;

        let size1 = this.getFreeSize();
        console.log('merge 1 '+size1)

        while(r<this.freeBufferRanges.length){

            const nr = this.findRangeAt(this.freeBufferRanges[r].end);
            if(nr){
                nr.start = this.freeBufferRanges[r].start;
                nr.size = nr.end - nr.start;
                this.freeBufferRanges.splice(r, 1);
            } else
                r++
        }

        let size2= this.getFreeSize();
        console.log('merge 2 '+size2)

    }

    unrefRange(range) {

        range.refCnt--;
        if(range.refCnt>0)
            return;

        for (let n = 0; n < this.usedBufferRanges.length; n++) {

            if(this.usedBufferRanges[n].start === range.start) {
                this.usedBufferRanges.splice(n, 1);

                /* insert new free range smaller first */
                let i=0;
                while(i<this.freeBufferRanges.length) {
                    if(this.freeBufferRanges[i].size > range.size) { break; }
                    i++;
                }
                this.freeBufferRanges.splice(i, 0, range);
                return;
            }
        }

        throw new Error('unrefRange range not found !', range);
    }

    addRef(range) {

        range.refCnt++;
        return range;
    }


    getBufferRange(size, name) {

        size *= 4;

        if((size & this.alignmask) != 0)
            size = (size & (~this.alignmask)) + this.align ;

        for (let n=0;n<this.freeBufferRanges.length;n++) {

            if (this.freeBufferRanges[n].size >= size) {

                const range = new BufferRange(this.freeBufferRanges[n].start, size);
                this.freeBufferRanges[n].size -= size;

                if(this.freeBufferRanges[n].size > 0)
                    this.freeBufferRanges[n].start += size;
                else
                    this.freeBufferRanges.splice(n, 1);
                
                range.name = name;
                range.flag = this.flag;
                
                this.usedBufferRanges.push(range);
                return range;
            }
        }

        console.warn('getBufferRange('+size+') error ', this.freeBufferRanges);

        return null;
    }

    async compact(copyEncoder) {

        if(this.freeBufferRanges.length < this.maxFreeRanges)
            return;
        
        if(this.usedBufferRanges.length == 0) {
            this.freeBufferRanges = [new BufferRange(0, this.size)];
            return;
        }

        if(this.usedBufferRanges.length == 1) {
            this.freeBufferRanges = [new BufferRange(this.usedBufferRanges[0].end, this.size - this.usedBufferRanges[0].end)];
            return;
        }

        return;

        console.log('compacting buffer ...');
        console.log(this.usedBufferRanges);
        console.log(this.freeBufferRanges);

        console.time('compacting');

        const usage = (this.type == 0) ? GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST : GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST;
        const rdusage =  (this.type == 0) ? GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_SRC : GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_SRC;

        await this.buffer.mapAsync( GPUMapMode.READ, 0,  this.size  );
        const buffer = this.buffer.getMappedRange(0, BUFFER_SIZE);
        const fbuffer = new Float32Array(buffer);
        console.log(fbuffer);

        this.buffer.unmap()

        const readBuffer = this.device.createBuffer({ size: this.size, usage: rdusage});

        const newBuffer =  this.device.createBuffer({ size: this.size, usage: usage});

        
        this.usedBufferRanges.sort(function(a,b){
            
            if(a.start < b.start)
                return -1;
            else if(a.start == b.start)
                return 0;
            else 
                return 1;
        });
        
        let curRange = null;
        let firstUsed = 0;
        let curOffset = 0;

        /*
        let bufferdata;
        let tmpTex;

        if(this.type == 2) {

            bufferdata = new Float32Array(2048 * 2048 * 4);
            tmpTex = new THREE.DataTexture(bufferdata, 2048, 2048, THREE.RGBAFormat, THREE.FloatType, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.NearestFilter, THREE.NearestFilter, 1, THREE.NoColorSpace);
            copyEncoder.copyTextureToTexture(new THREE.Vector2(0, 0), this.buffer, tmpTex,  0);

            const canvas = document.createElement( 'canvas' );
            canvas.width = this.buffer.image.width;
            canvas.height = this.buffer.image.height;
            const context = canvas.getContext( '2d' );
            context.drawImage( this.buffer.image, 0, 0 );
            const pixdata = context.getImageData( 0, 0, canvas.width, canvas.height );

            bufferdata = new Float32Array(2048 * 2048 * 4);

            for(let n = 0; n < 2048 * 2048 * 4; n++) {
                bufferdata[n] = pixdata[n] / 255.0;
            }
        }
        */
        
        for (let n = 0; n < this.usedBufferRanges.length; n++) {

            /* initialize new range to move */
            if(curRange == null) {
                curRange = new BufferRange(this.usedBufferRanges[n].start, this.usedBufferRanges[n].size);
                firstUsed = n;
                continue;
            }

            /* if contigous add current used range to the moving range */
            if(this.usedBufferRanges[n].start == curRange.end ) {
                curRange.size += this.usedBufferRanges[n].size;
                curRange.end = curRange.start + curRange.size;
            
            /*if not contigous, copy the current range at the current offset, and start on a new range */
            } else {

                if(curRange.start !== curOffset){

                    /*
                    if(this.type == 2) {

                        const firstLine = Math.floor(curRange.start / this.align);
                        const nLines = Math.ceil(curRange.size / this.align);
                        const firstFloat = firstLine * 2048 * 4;
                        const myzone = bufferdata.subarray(firstFloat, firstFloat + (nLines * 2048 * 4));
                        const tmpTex = new THREE.DataTexture(myzone, 2048, nLines, THREE.RGBAFormat, THREE.FloatType, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.NearestFilter, THREE.NearestFilter, 1, THREE.NoColorSpace);
                        const dstLine = Math.floor(curOffset / this.align );
                        
                        copyEncoder.copyTextureToTexture(new THREE.Vector2(0, dstLine),  tmpTex, this.buffer, 0);

                    } else */
                        copyEncoder.copyBufferToBuffer( this.buffer , curRange.start, newBuffer , curOffset, curRange.size);

                    for(let i = firstUsed; i < n; i++){
                        this.usedBufferRanges[i].start = curOffset;
                        this.usedBufferRanges[i].end = this.usedBufferRanges[i].start + this.usedBufferRanges[i].size;
                        curOffset += this.usedBufferRanges[i].size;
                    }
                }else
                    curOffset += curRange.size;

                curRange = null;
            }
        }

        if ((curRange !== null) && (curRange.start !== curOffset)) {

            /*
            if(this.type == 2) {

                const firstLine = Math.floor(curRange.start / this.align);
                const nLines = Math.ceil(curRange.size / this.align);
                const firstFloat = firstLine * 2048 * 4;
                const myzone = bufferdata.subarray(firstFloat, firstFloat + (nLines * 2048 * 4));
                const tmpTex = new THREE.DataTexture(myzone, 2048, nLines, THREE.RGBAFormat, THREE.FloatType, THREE.Texture.DEFAULT_MAPPING, THREE.ClampToEdgeWrapping, THREE.ClampToEdgeWrapping, THREE.NearestFilter, THREE.NearestFilter, 1, THREE.NoColorSpace);
                const dstLine = Math.floor(curOffset / this.align );
                
                copyEncoder.copyTextureToTexture(new THREE.Vector2(0, dstLine),  tmpTex, this.buffer, 0);

            } else */


                copyEncoder.copyBufferToBuffer( this.buffer , curRange.start, newBuffer , curOffset, curRange.size);
            

            for(let i = firstUsed; i <  this.usedBufferRanges.length; i++){
                this.usedBufferRanges[i].start = curOffset;
                this.usedBufferRanges[i].end = this.usedBufferRanges[i].start + this.usedBufferRanges[i].size;
                curOffset += this.usedBufferRanges[i].size;
            }
        }
            
        this.freeBufferRanges = [new BufferRange(curOffset, this.size - curOffset)];

        const oldBuff = this.buffer;
        this.buffer = newBuffer;
        oldBuff.destroy();

        console.timeEnd('compacting');

        console.log('compacted buffer');
        console.log(JSON.stringify(this.usedBufferRanges));
        console.log(JSON.stringify(this.freeBufferRanges));

    }
}
